import * as React from "react";
import { IBaseInputFieldProperty, IBaseProperty, IPropertyEditorProps, IUIFieldProps, registerUIField } from "../../common";
import { ColorPicker, Input, Label } from "uxp/components";
import {hasValue, parseValue, replaceWithData} from "../../../../util";
import { CustomColorPicker, Property, PropertyContainer, PropertyGroup, PropertyGroupTitle, PropertyTitle, TextAlignEditor } from "../../ui-props/common";
import { FieldProperty, FieldTitle, IFieldTitleProps } from "../../components/FieldTitle";
import {WidgetDesignerPillInput} from "../../pill-input/PillInput";

interface ITextFieldProperty extends IBaseInputFieldProperty {
	placeholder: string;
	textColor: string;
	backgroundColor: string;
	fontSize: string,
	textAlign: string,
	fieldLabel:IFieldTitleProps,

}

export const Field: React.FunctionComponent<IUIFieldProps<ITextFieldProperty>> = (props) => {
	let { value, onChange, placeholder, textColor, backgroundColor, fontSize, textAlign,fieldLabel } = props?.fieldProps || {};


	let styles: React.CSSProperties = {}
	if (hasValue(textColor)) styles.color = parseValue(textColor, props.contextData)
	if (hasValue(backgroundColor)) styles.backgroundColor = parseValue(backgroundColor, props.contextData)
	if (hasValue(fontSize)) styles.fontSize = fontSize
	if (hasValue(textAlign)) styles.textAlign = textAlign as any

	let isLiveMode = props.mode !== 'preview' &&  props.mode !== 'thumbnail';

	let _inputValue =  isLiveMode ?
		replaceWithData(value || '', props.contextData) : (value || '')

	let _placeholder =  isLiveMode ?
		replaceWithData(placeholder || '', props.contextData) :  (placeholder || '')

	return (
		<div className={`ui-field ${props.mode}`} >
			<FieldTitle {...props?.fieldProps?.fieldLabel || {} } />
			<Input
				value={_inputValue}
				placeholder={_placeholder}
				onChange={onChange}
				styles={styles}
			/>
		</div>
	)
}

export const EmailField: React.FunctionComponent<IUIFieldProps<ITextFieldProperty>> = (props) => {
	let {
		value,
		onChange,
		placeholder,
		textColor,
		backgroundColor,
		fontSize,
		textAlign,fieldLabel
	} = props?.fieldProps || {};

	let styles: React.CSSProperties = {}
	if (hasValue(textColor)) styles.color = textColor
	if (hasValue(backgroundColor)) styles.backgroundColor = backgroundColor
	if (hasValue(fontSize)) styles.fontSize = fontSize
	if (hasValue(textAlign)) styles.textAlign = textAlign as any
	const hasValueSetRef = React.useRef<boolean>(false)

	let isLiveMode = props.mode !== 'preview' &&  props.mode !== 'thumbnail';

	let _inputValue =  isLiveMode ?
		replaceWithData(value || '', props.contextData) : (value || '')
	let _placeholder =  isLiveMode ?
		replaceWithData(placeholder || '', props.contextData) :  (placeholder || '')

	React.useEffect(() => {
		if (!hasValueSetRef.current && (!props.mode || props.mode =='live')) {
			(props.uxpContext as any)?.getUserDetails()?.then((ud:any)=>{
				console.log('UD',ud);
				if (ud.email) {
					hasValueSetRef.current = true
					onChange(ud.email);
				}
			});
			
		}
	}, [props])
	return (
		<div className={`ui-field ${props.mode}`} >
			<FieldTitle {...props?.fieldProps?.fieldLabel || {} } />
			<Input
				type="email"
				value={_inputValue}
				placeholder={_placeholder}
				onChange={onChange}
				styles={styles}
			/>
		</div>
	)
}


export const NameField: React.FunctionComponent<IUIFieldProps<ITextFieldProperty>> = (props) => {
	let { value, onChange, placeholder, textColor, backgroundColor, fontSize, textAlign,fieldLabel } = props?.fieldProps || {};

	let styles: React.CSSProperties = {}
	if (hasValue(textColor)) styles.color = textColor
	if (hasValue(backgroundColor)) styles.backgroundColor = backgroundColor
	if (hasValue(fontSize)) styles.fontSize = fontSize
	if (hasValue(textAlign)) styles.textAlign = textAlign as any
	const hasValueSetRef = React.useRef<boolean>(false)

	console.log(props.contextData)
	let isLiveMode = props.mode !== 'preview' &&  props.mode !== 'thumbnail';

	let _inputValue =  isLiveMode ?
		replaceWithData(value || '', props.contextData) : (value || '')
	let _placeholder =  isLiveMode ?
		replaceWithData(placeholder || '', props.contextData) :  (placeholder || '')


	React.useEffect(() => {
		if (!hasValueSetRef.current && (!props.mode || props.mode =='live')) {
			(props.uxpContext as any)?.getUserDetails()?.then((ud:any)=>{
				if (ud.email) {
					hasValueSetRef.current = true
					onChange(ud.name);
				}
			});
			
		}
	}, [props])
	return (
		<div className={`ui-field ${props.mode}`} >
			<FieldTitle {...props?.fieldProps?.fieldLabel || {} } />
			<Input
				type="text"
				value={_inputValue}
				placeholder={_placeholder}
				onChange={onChange}
				styles={styles}
			/>
		</div>
	)
}



export const PropertyEditor: React.FunctionComponent<IPropertyEditorProps<ITextFieldProperty>> = (props) => {
	return <PropertyContainer>
		<PropertyGroup>
			<PropertyGroupTitle>Text Input</PropertyGroupTitle>

			<Property>
				<PropertyTitle>Value</PropertyTitle>
				<WidgetDesignerPillInput
					contextData={props.contextData}
					value={props.uiProps.value || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { value: s }))}
					className="widget-designer-input"
				/>
			</Property>
			
			<Property>
				<PropertyTitle>Placeholder</PropertyTitle>
				<WidgetDesignerPillInput
					contextData={props.contextData}
					value={props.uiProps.placeholder || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { placeholder: s }))}
					className="widget-designer-input"
				/>
			</Property>

			{/* <Property>
				<PropertyTitle>Text Color </PropertyTitle>
				<CustomColorPicker contextData={props.contextData}
					color={props.uiProps.textColor || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { textColor: s }))}
				/>
			</Property>

			<Property>
				<PropertyTitle>Align</PropertyTitle>
				<TextAlignEditor
					value={props.uiProps.textAlign || 'left'}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { textAlign: s }))}
				/>
			</Property>

			<Property>
				<PropertyTitle>Background Color </PropertyTitle>
				<CustomColorPicker contextData={props.contextData}
					color={props.uiProps.backgroundColor || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { backgroundColor: s }))}
				/>
			</Property> */}

		</PropertyGroup>
		<FieldProperty uiProps={props.uiProps} onChange={props.onChange} />
	</PropertyContainer>;
}

registerUIField({
	id: 'text',
	category: 'inputs',
	description: 'Text Input',
	field: Field,
	propertyEditor: PropertyEditor,
	isInputField: true,
	defaultProps: {
		placeholder: 'Enter some text',
		backgroundColor: '',
		textColor: '',
		fontSize: '12px',
		textAlign: 'left',
		fieldLabel:{
			label:'Text Label',
		},
	},
	type:'text'

});

registerUIField({
	id: 'email',
	category: 'inputs',
	description: 'Email Input',
	field: EmailField,
	propertyEditor: PropertyEditor,
	isInputField: true,
	defaultProps: {
		placeholder: 'me@acme.com',
		backgroundColor: '',
		textColor: '',
		fontSize: '12px',
		textAlign: 'left',
		fieldLabel:{
			label:'Email Address',
		},
	},
	type:'email'

});
registerUIField({
	id: 'name',
	category: 'inputs',
	description: 'Name Input',
	field: NameField,
	propertyEditor: PropertyEditor,
	isInputField: true,
	defaultProps: {
		placeholder: 'John Doe',
		backgroundColor: '',
		textColor: '',
		fontSize: '12px',
		textAlign: 'left',
		fieldLabel:{
			label:'Name',
		},
	},
	type: 'name'

});
